export default "__VITE_ASSET__8NsmZzKQ__"